import * as React from 'react';
import { useDispatch } from 'react-redux';

import { getTermValue } from '../../../../packages/JsonQuery';

import { IJsonQuery } from '../../../json_query';

import { setIsByCommercialOwnerSelected } from '../../state/is_by_commercial_owner';

import { IsByCommercialOwner as IsByCommercialOwnerComponent } from './isByCommercialOwner';

interface IIsByCommercialOwnerContainerProps {
  jsonQuery: IJsonQuery;
}

export const IsByCommercialOwner: React.FC<IIsByCommercialOwnerContainerProps> = ({ jsonQuery }) => {
  const commercialOwnerFilterValue = getTermValue('is_by_commercial_owner')(jsonQuery) || false;

  const dispatch = useDispatch();
  const onCommercialOwnerFilterChange = React.useCallback(() => {
    dispatch(setIsByCommercialOwnerSelected());
  }, []);

  return (
    <IsByCommercialOwnerComponent value={commercialOwnerFilterValue} onValueChange={onCommercialOwnerFilterChange} />
  );
};

IsByCommercialOwner.displayName = 'IsByCommercialOwner';
